<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2023-03-28 15:58:19
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
          class="main-r_top_nav active"
      >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">数据类型：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";
  export default {
    name: "statusFeedback",

    components: {onlineDoc},
    data() {
      return {
        onlineData: {
          //接口描述
          apiDesc: "拦截下发回执接⼝将拦截下发的结果通知到客户，客户需要在开放平台配置回传地址。",

          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: 'Headers',
              value: [
                {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: "接入方在平台的api账户标识",},
                {name: "digest", type: "String", require: "Y", normal: "", describe: "签名字符串",},
                {name: "timestamp", type: "Number", require: "Y", normal: "", describe: "时间戳，毫秒",},
              ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title: "业务参数",
              value: [
                {name: "mailNo", type: "String", require: "Y", normal: "", describe: "通知拦截结果的运单号"},
                {name: "interceptResult", type: "String", require: "Y", normal: "", describe: `拦截结果，取值如下 ：<p>"success"：代表拦截成功，</p><p>"fail"：代表拦截失败，</p><p>"processing"：代表拦截进⾏中</p>`},
                {name: "returnMailNo", type: "String", require: "N", normal: "", describe: "拦截成功后，产⽣的退回单号（仅拦截成功状态时回传）"},
                {name: "errorDesc", type: "String", require: "N", normal: "", describe: "拦截失败原因（仅拦截失败状态时回传）"},
              ]
            }
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [

            //   响应参数
            {
              title: '响应参数',
              value: [
                {name: "code", type: "String", require: "Y", normal: "", describe: "返回码，见附录"},
                {name: "msg", type: "String", require: "Y", normal: "", describe: "描述"},
              ]
            }
          ],
          //请求示例
          requestCode: `Header：
apiAccount=178337126125932605
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921
Body：
bizContent={
 "mailNo": "UT0000456908252",
 "interceptResult": "success",
 "returnMailNo": "UT0000456908252"
}`,
          //返回示例
          responseCode: {
            'code': '1',
            'msg': 'success'
        } ,
        errcodeJson: []
        }
      }
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
